/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const JSG = require('../../JSG');
const AbstractItemCommand = require('./AbstractItemCommand');
const Graph = require('../model/Graph');
const Expression = require('../expr/Expression');
const JSONWriter = require('../../commons/JSONWriter');

const writeExpression = (expr) => {
	const data = {};
	if (expr instanceof Expression) {
		const writer = new JSONWriter();
		writer.writeStartDocument();
		expr.save('expression', writer);
		writer.writeEndDocument();
		data.json = writer.flush();
		data.type = expr.constructor.name;
	}
	return data;
};
/**
 * @class AddSheetNameCommand
 * @type {module.AddSheetNameCommand}
 */
module.exports = class AddSheetNameCommand extends AbstractItemCommand {
	constructor(item, name) {
		super(item);

		this._name = name;
	}

	toObject() {
		const data = super.toObject();
		data.sheetname = this._name.getName();
		data.expr = writeExpression(this._name.getExpression());
		return data;
	}
	undo() {
		if (this._graphItem instanceof Graph) {
			JSG.sheetNames.delete(this._name);
		} else {
			const data = this._graphItem.model.cells;
			data.deleteName(this._name);
		}

		this._graphItem.getGraph().markDirty();
	}

	redo() {
		if (this._graphItem instanceof Graph) {
			JSG.sheetNames.add(this._name);
		} else {
			const data = this._graphItem.model.cells;
			data.addName(this._name);
		}

		this._graphItem.getGraph().markDirty();
	}

	doAfterRedo() {}

	doAfterUndo() {}
};
